import img01 from '../assets/images/coverage/01.webp';
import img02 from '../assets/images/coverage/02.webp';
import img03 from '../assets/images/coverage/03.webp';
import img04 from '../assets/images/coverage/04.webp';
import img05 from '../assets/images/coverage/05.webp';
import img06 from '../assets/images/coverage/06.webp';
import img07 from '../assets/images/coverage/07.webp';

export const coverageItems = [
  {
    n: '01',
    name: '환자 클레임',
    pain: '전화 한 통, 방문 한 번에 진료가 멈춥니다',
    desc: '부당한 요구를 거절하기도, 들어주기도 어렵습니다. 첫 대응 방식이 이후 협상의 기준점이 됩니다.',
    img: img01,
    slug: 'patient-claim',
    ctaLabel: '클레임 대응 상담',
    detailIntro:
      '환자 클레임은 초기 대응이 결과를 결정합니다. 감정적 반응이나 섣부른 합의는 이후 분쟁을 악화시킬 수 있습니다.',
    detailSections: [
      {
        heading: '흔한 클레임 유형',
        bullets: [
          '진료 결과에 불만을 품고 합의금을 요구하는 환자',
          '녹취·영상 촬영을 암시하며 압박하는 경우',
          '보호자가 대신 강경한 요구를 전달하는 경우',
        ],
      },
      {
        heading: '초기 대응 원칙',
        bullets: [
          '"제가 잘못했습니다"라는 말은 법적 불리함으로 직결',
          '금전 보상을 먼저 언급하지 않는 것',
          '법무법인 창구로 신속히 이관하는 것',
        ],
      },
    ],
  },
  {
    n: '02',
    name: '진료비 미납',
    pain: '청구해도 묵묵부답, 연락도 안 됩니다',
    desc: '소액이라 그냥 넘기다 보면 반복됩니다. 법적 절차 없이도 해결되는 경우가 많습니다.',
    img: img02,
    slug: 'unpaid-fees',
    ctaLabel: '미납 채권 회수 상담',
    detailIntro:
      '진료비 미납은 반복될수록 손실이 누적됩니다. 내용증명 한 장으로 태도가 달라지는 경우가 많습니다.',
    detailSections: [
      {
        heading: '대응 가능한 방법',
        bullets: [
          '내용증명 발송 (법무법인 명의로 효과 극대화)',
          '지급명령 신청 (법원을 통한 간이 채권 회수)',
          '소액 민사소송',
        ],
      },
      {
        heading: '주의 사항',
        bullets: [
          '직접 연락 시 녹취·분쟁으로 번질 수 있음',
          '개인정보 활용 범위 준수 필요',
          '시효 관리 (3년 이내 조치 필요)',
        ],
      },
    ],
  },
  {
    n: '03',
    name: '환불 및 손해배상 요청',
    pain: '진료비를 돌려달라, 피해를 보상하라고 요구합니다',
    desc: '정당한 요구인지 아닌지 판단이 서지 않으면 대응할 수가 없습니다. 과실 여부는 전문가가 판단합니다.',
    img: img03,
    slug: 'refund-damages',
    ctaLabel: '손해배상 자문 요청',
    detailIntro:
      '환불·손해배상 요구는 법적 근거가 있는지를 먼저 따져야 합니다. 응하기 전에 반드시 전문가와 확인하세요.',
    detailSections: [
      {
        heading: '판단이 필요한 부분',
        bullets: [
          '의학적 기준으로 과실이 인정되는지 여부',
          '설명의무·동의서 작성 여부',
          '인과관계 성립 여부',
        ],
      },
      {
        heading: '대응 방향',
        bullets: ['과실 없는 경우 거절 근거 마련', '합의 진행 시 적정 금액 산정', '조정·소송 대응'],
      },
    ],
  },
  {
    n: '04',
    name: '협박',
    pain: '"가만두지 않겠다"는 말 한마디가 진료를 마비시킵니다',
    desc: '협박은 형사 고소 대상입니다. 증거를 확보하고 즉시 법적 조치를 취할 수 있습니다.',
    img: img04,
    slug: 'threats',
    ctaLabel: '협박 대응 상담',
    detailIntro:
      '협박·공갈은 형사 처벌 대상입니다. 감정적으로 대응하기보다 증거를 남기고 법적 절차로 전환하는 것이 유리합니다.',
    detailSections: [
      {
        heading: '법적 대응 경로',
        bullets: ['협박죄·공갈죄 형사 고소', '접근금지 가처분 신청', '손해배상 민사 청구'],
      },
      {
        heading: '즉시 해야 할 것',
        bullets: [
          '통화·문자·SNS 내용 캡처 및 보관',
          '목격자 진술 확보',
          '경위서 작성 (날짜·내용 기록)',
        ],
      },
    ],
  },
  {
    n: '05',
    name: '업무방해 (욕설·난동)',
    pain: '진료실에서 고성과 욕설, 다른 환자들이 다 듣습니다',
    desc: '업무방해죄는 즉시 고소 가능합니다. 현장 대응 방법부터 법적 조치까지 안내드립니다.',
    img: img05,
    slug: 'obstruction',
    ctaLabel: '업무방해 대응 상담',
    detailIntro:
      '욕설·난동은 업무방해죄에 해당합니다. 현장에서의 대응 방식과 이후 법적 조치를 함께 안내드립니다.',
    detailSections: [
      {
        heading: '현장 대응 원칙',
        bullets: [
          '자체 제압 금지—신체 접촉은 역고소 빌미 제공',
          'CCTV 영상·직원 진술 즉시 확보',
          '112 신고 및 경위 기록',
        ],
      },
      {
        heading: '법적 조치',
        bullets: ['업무방해죄 형사 고소', '진료 거부 공고문 발송', '민사 손해배상 청구'],
      },
    ],
  },
  {
    n: '06',
    name: '지속적 진료 요구·괴롭힘',
    pain: '진료를 거부할 수도, 계속 받아줄 수도 없는 상황입니다',
    desc: '반복적인 민원, 부당한 진료 요구는 의료법상 진료 거부 사유가 될 수 있습니다.',
    img: img06,
    slug: 'harassment',
    ctaLabel: '진료 거부 요건 확인',
    detailIntro:
      '의사에게도 정당한 진료 거부권이 있습니다. 요건을 확인하고 법적 위험 없이 관계를 정리할 수 있습니다.',
    detailSections: [
      {
        heading: '해당되는 상황',
        bullets: [
          '진료와 무관한 요구를 반복적으로 제기하는 환자',
          '직원에게 언어·신체적 위협을 가하는 경우',
          '허위 민원을 반복 제기해 업무를 방해하는 경우',
        ],
      },
      {
        heading: '합법적 진료 종결 방법',
        bullets: [
          '진료 거부 통보 공문 발송',
          '의료법상 요건 충족 여부 검토',
          '경고장 발송 후 고소 전환',
        ],
      },
    ],
  },
  {
    n: '07',
    name: '1인 시위',
    pain: '병원 앞에서 피켓을 들고 서 있으면 환자들이 발길을 돌립니다',
    desc: '허위 사실 유포를 포함한 1인 시위는 업무방해·명예훼손으로 대응 가능합니다.',
    img: img07,
    slug: 'protest',
    ctaLabel: '시위 대응 상담',
    detailIntro:
      '1인 시위는 표현의 자유로 보호되지만, 허위 사실 적시나 반복적 방해 행위는 법적 제재가 가능합니다.',
    detailSections: [
      {
        heading: '법적 대응 가능 범위',
        bullets: [
          '허위 사실 적시에 의한 명예훼손 고소',
          '업무방해죄 적용 요건 검토',
          '가처분 신청으로 즉시 중단 요구',
        ],
      },
      {
        heading: '증거 수집',
        bullets: [
          '시위 내용·피켓 문구 촬영',
          '진료 매출·예약 감소 데이터 보관',
          '목격자 진술 및 CCTV 확보',
        ],
      },
    ],
  },
];
